import { CircularProgress, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { Params, useParams } from "react-router-dom";
import { useGetScenesQuery } from "../../services/scene.service";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetMarksQuery } from "../../services/marks.service";
import { PieChart } from "@mui/x-charts";
import { VTButton, VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import VTTimelineItem from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTimelineItem";
import { getImageForSceneOrDefaultImageIfPreviewImageDoesntExist } from "../../utils/getImageForSceneOrDefaultImageIfPreviewImageDoesntExist";
import { useGetScenarioOverviewQuery } from "../../services/scenario.service";
import { useGetScenarioAttemptsQuery } from "../../services/tracking.service";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { setCurrentSidePanel, setSelectedUser } from "../../store/slices/current.slice";
import MarksViewItem from "./MarksViewItem";
import ScoresContainer from "./ScoresContainer";
import zIndex from "@mui/material/styles/zIndex";
import NoUser from "../../assets/images/NoScenarios.svg";

interface IProps {
    drawWidth: number;
}

export default function ViewMarksContainer({ drawWidth }: IProps) {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { scenarioId }: Readonly<Params<string>> = useParams();

    const { data: scenes } = useGetScenesQuery(scenarioId ? scenarioId : "");
    const { currentSidePanel, selectedAttempt, selectedUser, currentSidePannelDesiredWidth } = useAppSelector(
        (state) => state.currentReducer,
    );
    const { data: tracking } = useGetScenarioAttemptsQuery({ scenarioId: scenarioId });
    const [correctSceneList, setCorrectSceneList] = useState<string[]>([]);

    if (selectedUser) {
        return (
            <Grid container sx={{ position: "relative", heigth: "100%", zIndex: 10000 }}>
                <Grid
                    item
                    container
                    sx={{
                        position: "absolute",
                        left: "20px",
                        top: "20px",
                        zIndex: 10000,
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: "15px",
                        width: "220px",
                        height: "180px",
                    }}
                >
                    <Grid container sx={{ width: "100%", heigth: "100%", position: "relative" }}>
                        <VTTypography sx={{ position: "absolute", left: "10px", top: "10px" }}>User Score</VTTypography>

                        <VTTypography
                            type="Heading2"
                            sx={{ position: "absolute", left: "60px", top: "60px", color: "green" }}
                        >
                            6
                        </VTTypography>
                        <VTTypography
                            type="Heading1"
                            sx={{ position: "absolute", left: "100px", top: "70px", color: "green" }}
                        >
                            /
                        </VTTypography>
                        <VTTypography
                            type="Heading2"
                            sx={{ position: "absolute", left: "130px", top: "100px", color: "green" }}
                        >
                            6
                        </VTTypography>
                    </Grid>
                </Grid>
                {selectedUser && (
                    <ScoresContainer drawWidth={drawWidth} viewMarks correctSceneList={correctSceneList} />
                )}
            </Grid>
        );
    } else {
        return (
            <Grid
                container
                sx={{ height: "100%", backgroundColor: theme.palette.background.default }}
                justifyContent={"center"}
                alignContent={"center"}
            >
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTTypography type={"Heading2"} sx={{ marginBottom: "30px" }}>
                        No user selected
                    </VTTypography>
                </Grid>
                <Grid item>
                    <img src={NoUser} />
                </Grid>{" "}
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTTypography type={"Heading4"} sx={{ marginTop: "20px" }}>
                        Please select a user from the side panel on the left
                    </VTTypography>
                </Grid>
                <Grid item xs={12} container justifyContent={"center"}>
                    <VTButton
                        onClick={() => {
                            dispatch(
                                setCurrentSidePanel({
                                    currentTab: "Users",
                                    currentWidth: currentSidePannelDesiredWidth,
                                    option: undefined,
                                }),
                            );
                        }}
                    >
                        Choose user
                    </VTButton>
                </Grid>
            </Grid>
        );
    }
}
